import { Avatar, Box, Card, Typography } from '@mui/material';
import { useGetIdentity } from 'react-admin';
import { customPalette } from '../../../themes/customTheme';

export const WelcomeBlock = () => {
  const { identity } = useGetIdentity();

  return (
    <Card
      elevation={0}
      sx={{
        background: '#fff',
        padding: '20px',
        marginTop: 2,
        marginBottom: '1em',
      }}
    >
      <Box display="flex" gap={3} alignItems="center">
        <Box>
          <Avatar
            src={identity?.avatar}
            sx={{
              width: 70,
              height: 70,
              fontSize: '2rem',
              backgroundColor: customPalette.primary.main,
            }}
          >
            {identity?.fullName?.[0]?.toUpperCase()}
          </Avatar>
        </Box>
        <Box>
          <Typography variant="h5" gutterBottom color={customPalette.greyDark}>
            ¡Bienvenido{identity?.fullName ? `, ${identity.fullName}` : ''}!
          </Typography>
        </Box>
      </Box>
    </Card>
  );
};

export default WelcomeBlock;
